import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTooltipModule } from '../tooltip/module'
import { IcosMenuItemGroup } from './menu-item-group'
import { IcosMenuItem } from './menu-item'
import { IcosSubmenu } from './submenu'
import { IcosMenu } from './menu'


@NgModule({
  declarations: [IcosMenu, IcosSubmenu, IcosMenuItem, IcosMenuItemGroup],
  exports: [IcosMenu, IcosSubmenu, IcosMenuItem, IcosMenuItemGroup],
  imports: [CommonModule, IcosTooltipModule.forRoot()],
  entryComponents: [IcosMenu, IcosSubmenu, IcosMenuItem, IcosMenuItemGroup],
})
export class IcosMenusModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosMenusModule, providers: [] }
  }
}
